import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        valueLabel: '=',
        classifier: '=',
        cancel: '&'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.cancel()"></button>
            <h2>{{ 'general.Manage translations' | translate }}</h2>
        </div>
        <div class="modal-body form">
            <form-wrapper form="vm.form">
                <table class="data01">
                    <tr>
                        <th>{{ 'general.Label' | translate }}</th>
                        <th>{{ vm.defaultLanguage }} <small>({{ 'translation.default' | translate}})</small></th>
                        <th ng-repeat="(code, value) in vm.languages" ng-if="code!==vm.defaultLanguage">
                            <label>
                                <input type="checkbox" ng-model="vm.languages[code]" ng-click="$event.stopPropagation();vm.toggleCheckbox(code)"> {{ code }}
                            </label>
                        </th>
                    </tr>
                    <tr>
                        <td>{{ vm.valueLabel }}</td>
                        <td class="input">
                            <form-row error="vm.form.errors.classifierI18ns[vm.defaultLanguage].value">
                                <input ng-model="vm.form.model.classifierI18ns[vm.defaultLanguage].value" class="form-control">
                                <form-row-error></form-row-error>
                            </form-row>
                        </td>
                        <td class="input" ng-repeat="(code, value) in vm.languages" ng-if="code!==vm.defaultLanguage">
                            <form-row error="vm.form.errors.classifierI18ns[code].value">
                                <input ng-model="vm.form.model.classifierI18ns[code].value" ng-if="value" class="form-control">
                                <form-row-error></form-row-error>
                            </form-row>
                        </td>
                    </tr>
                </table>
            </form-wrapper>
        </div>
        <div class="modal-footer">
        <ul class="actions01">
            <li class="primary"><button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button></li>
            <li><button class="btn discrete" type="button" ng-click="vm.cancel()">{{ 'general.Cancel' | translate }}</button></li>
        </ul>
        </div>
    `
})
export default class {
    constructor ($state, $translate, lodash, TokenService, ModalService, FormFactory) {
        this.$state = $state;
        this.$translate = $translate;
        this.lodash = lodash;
        this.TokenService = TokenService;
        this.ModalService = ModalService;
        this.FormFactory = FormFactory;
    }

    $onInit () {
        this.defaultLanguage = this.TokenService.getCompanyLanguage();
        this.languages = {};
        this.lodash.forEach(this.TokenService.getCompanySupportedLanguages(), (code) => {
            this.languages[code] = this.lodash.has(this.classifier.classifierI18ns, code);
        });
        this.form = this.FormFactory.create(this.classifier, model => model.$update({
            id: model.id,
            expand: 'classifierI18ns'
        }));
    }

    toggleCheckbox (code) {
        const confirmMessage = this.$translate.instant('translations.Are you sure you would like to remove this translation?');
        this.form.model.classifierI18ns[code] = '';

        if (!this.languages[code]) {
            // remove checkbox only after it's confirmed
            this.languages[code] = !this.languages[code];

            this.ModalService.confirm(confirmMessage, 'medium').then(() => {
                // now uncheck
                this.languages[code] = !this.languages[code];
                delete this.form.model.classifierI18ns[code];

                // if language is disabled, make sure no error messages are left in ui
                if (this.lodash.has(this.form.errors.classifierI18ns, code)) {
                    delete this.form.errors.classifierI18ns[code];
                }
            });
        }
    }

    beforeSave () {
        // course fields are coursy classifiers, so value should be also set
        this.form.model.value = this.form.model.classifierI18ns[this.defaultLanguage].value;
    }

    save () {
        this.beforeSave();
        this.form.save().then(() => window.location.reload(true));
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/classifier/translation/index.js